"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoBackLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
exports.GoBackLink = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", color: "grey", icon: ["fal", "chevron-left"] }, void 0), (0, jsx_runtime_1.jsx)(typography_1.A, { ref: ref, href: props.href ? props.href : "#", children: props.linkTranslation }, void 0)] }, void 0));
});
const Wrapper = styled_components_1.default.div `
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  padding-left: 0.5rem;
  margin-right: 1.5rem;

  & a {
    margin-left: ${({ theme }) => theme.spacings.xs};
    text-decoration: underline;
  }
`;
//# sourceMappingURL=GoBackLink.js.map